module.exports = __webpack_public_path__ + "img/DSCN0274.ed674bc3.jpg";